import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import ar0 from "../../../assets/images/Blogs/ArabicBlog/ar0.webp";
// import forbs from "../../../assets/images/Blogs/Forbes/paolo_khayat_forbes.webp";
import rare0 from "../../../assets/images/Blogs/Vintage/vintage0.webp";
import chanel from "../../../assets/images/Blogs/CareHanbag/care1.webp";
import blog3 from "../../../assets/images/Blogs/InspiringEmiratiWomen/emirati0.webp";
import blog4 from "../../../assets/images/Blogs/Rolex/rolex0.webp";
import viewall from "../../../assets/images/view-all.svg";
import backbtn from "../../../assets/images/backbutton.svg";
function TheCrypt() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }
  const Blogs = [
    // {
    //   id: "0",
    //   link: "https://www.forbesmiddleeast.com/lists/30-under-30-2023/paolo-khayat/",
    //   image: forbs,
    //   txtAr: "مؤسس ورئيس تنفيذ لباس يصل إلى لوحة فوربس العالمية تحت ال-٣٠",
    //   txt: "Libas' CEO makes it to the Forbes' 30 Under 30 list",
    //   alt: "Libas' CEO makes it to the Forbes' 30 Under 30 list",
    //   isForbs: true,
    // },
    {
      id: "0",
      link: "/VintageFashionStoryPopularityandImpaconModernStyle",
      image: rare0,
      txt: t("crypttxt0"),
      alt: "Several shopping bags to highlight fast fashion",
      date: "06 July 2023",
    },
    {
      id: "1",
      link: "/six-tips-you-didnt-know-on-how-to-take-care-of-your-chanel-bag",
      image: chanel,
      txt: t("crypttxt1"),
      alt: "6 Tips You Didn't Know On How To Take Care Of Your Chanel Bag",
      date: "04 October 2023",
    },
    {
      id: "2",
      link: "/5-inspiring-khaleeji-women-and-their-best-fashion-moments",
      image: blog3,
      txt: t("crypttxt2"),
      alt: "5 Khaleeji Women Who Are Fashion Icons",
      date: "13 September 2023",
    },
    {
      id: "3",
      link: "/how-to-authenticate-a-used-Rolex-by-Libas",
      image: blog4,
      txt: t("crypttxt3"),
      alt: "How To Authenticate Used Rolex Watches With The Help Of Libas",
      date: "31 July 2023",
    },
    // {
    //   id: "3",
    //   link: "/fall-2023-trends",
    //   image: fall0,
    //   txt:t("falltrends") ,
    //   alt:"Fall 2023 trends and Bella Hadid wearing polka dots at the Balenciaga Dinner Party in Paris 07/06/2022",
    // },
  ];
  return (
    <>
      <div className="px-md-5 px-0  pt-lg-0 pt-4 d-flex">
        {/* english */}
        {i18n.language == "en" ? (
          <>
            <>
              <div
                style={{ textAlign: "start", direction: "ltr" }}
                className="title-section2"
              >
                {t("The")}
              </div>
              <span
                style={{ direction: "ltr" }}
                className={`title-section22  ${
                  i18n.language == "en" ? "ps-2" : "pe-3 "
                }`}
              >
                {t("Crypt")}
              </span>
            </>
          </>
        ) : (
          <>
            {/* arabic */}
            <span
              style={{ direction: "ltr" }}
              className={`title-section22  ${
                i18n.language == "en" ? "ps-2" : "pe-3 "
              }`}
            >
              {t("The")} {t("Crypt")}
            </span>
          </>
        )}

        <div style={{ flexGrow: 1 }} />
        <a
          className={`d-flex justify-content-center shoptopick px-lg-0 px-3  pt-lg-5 pt-4  ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
          onClick={() =>
            navigate("/all-blogs") &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          style={arabStyle}
          aria-label="Shop Top Picks - View All Top Picks"
        >
          {i18n.language == "en" ? (
            <>
              <div
                className={`me-2 shoptopick ${
                  i18n.language == "en" ? `text-start` : `text-startAr`
                }`}
              >
                {t("viewall")}
              </div>

              <img
                alt="main"
                src={viewall}
                style={{ width: "19px" }}
                className="plusbtn"
              />
            </>
          ) : (
            <>
              {" "}
              <img
                alt="main"
                src={backbtn}
                style={{ width: "98px" }}
                className="plusbtn"
              />
            </>
          )}
        </a>
      </div>

      <div className="sub-section px-md-5 px-0 pt-md-0 pt-2 pb-4 pb-lg-5 ">
        {t("home-subcrypt")}
      </div>
      <div className="row  mx-0 pb-4">
        <div
          className="col-12 d-flex scroll px-md-5 px-0 justify-content-between   mx-0 "
          id="style-2"
        >
          {Blogs.map((blog) =>
            blog.isForbs ? (
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(blog.link, "_blank", "noopener,noreferrer")
                }
                id={blog.id}
              >
                <div
                  className={`  ${
                    i18n.language == "en" ? "pe-md-4 pe-3 " : "ps-md-4 ps-3   "
                  }`}
                >
                  <img src={blog.image} className="crypt-img" alt={blog.alt} />

                  <div
                    className={` pt-3 ${
                      blog.txtAr == "crypttxtAr" ? "crypttxtAr" : `crypt-txt`
                    }`}
                  >
                    {blog.txt}
                  </div>
                  {/* <div className="pb-md-4 pt-md-0 pt-3 pb-md-0 pb-3 text-center">
                    <div className="crypt-txt2  crypt-txt2link">
                      {t("Read more")}
                    </div>
                  </div> */}
                </div>
              </div>
            ) : (
              <div
                className="pb-3"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(blog.link) &
                  window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                }
                id={blog.id}
              >
                <div
                  className={`  ${
                    i18n.language == "en" ? "pe-md-4 pe-3 " : "ps-md-4 ps-3  "
                  }`}
                >
                  <img src={blog.image} className="crypt-img" alt={blog.alt} />
                  <div
                    className="crypt_sub-date"
                    style={{
                      textAlign: i18n.language == "en" ? "start" : "end",
                      direction: "ltr",
                    }}
                  >
                    {blog.date}
                  </div>
                  <div className={`   pt-3 ${`crypt-txt`}`}>{blog.txt}</div>
                  {/* <div className="pb-md-4 pt-md-0 pt-3 pb-md-0 pb-3 text-center">
                    <div className="crypt-txt2  crypt-txt2link">
                      {t("Read more")}
                    </div>
                  </div> */}
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* <div className="text-center  pt-lg-5 pt-4 pb-md-5 pb-4 justify-content-center d-flex align-items-center">
        <Link
          to="/all-blogs"
          className="btn-shop buttonH  d-flex justify-content-center align-items-center"
          onClick={() =>
            navigate("/all-blogs") &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          style={{ textDecoration: "none" }}
        >
          {t("VIEWALLAR")}
        </Link>
      </div> */}
    </>
  );
}

export default TheCrypt;
